import { useEffect, useRef } from "react";
import { CALL_API } from "../context/constValues";

const cleanLabel = (value) => String(value || "").replace(/\s+/g, " ").trim().slice(0, 180);
const currentToken = () => localStorage.getItem("token") || sessionStorage.getItem("token");

export default function AdminActivityTracker({ enabled }) {
  const queue = useRef([]);

  useEffect(() => {
    if (!enabled) return undefined;

    const flush = () => {
      const token = currentToken();
      if (!token || queue.current.length === 0) return;
      const events = queue.current.splice(0, 50);
      fetch(`${CALL_API}/admin/activity`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        body: JSON.stringify({ events }),
        keepalive: true,
      }).catch(() => { queue.current = events.concat(queue.current).slice(-100); });
    };

    const onClick = (event) => {
      const target = event.target?.closest?.("button, a, [role='button'], input[type='button'], input[type='submit']");
      if (!target) return;
      const label = cleanLabel(target.getAttribute("aria-label") || target.getAttribute("title") || target.innerText || target.value);
      const href = target.getAttribute("href") || "";
      const isDownload = target.hasAttribute("download") || /descargar|exportar|excel|pdf|\.xlsx?|\.pdf|\.csv/i.test(`${label} ${href}`);
      queue.current.push({
        type: isDownload ? "DOWNLOAD" : "CLICK",
        action: label || target.tagName,
        route: window.location.pathname,
        targetType: target.tagName,
        targetId: target.id || null,
        details: { href: href.slice(0, 300) || null },
      });
      if (queue.current.length >= 10) flush();
    };

    document.addEventListener("click", onClick, true);
    const interval = window.setInterval(flush, 5000);
    window.addEventListener("pagehide", flush);
    return () => {
      document.removeEventListener("click", onClick, true);
      window.removeEventListener("pagehide", flush);
      window.clearInterval(interval);
      flush();
    };
  }, [enabled]);

  return null;
}
